import CONTRATO_ESTIMACIONES from '@/graphql/querys/administracion/ejecucion/estimaciones/contratoEstimaciones.gql';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_PROGRAMAS_OBRAS from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import CONTRATO_CATALOGO_CONCEPTOS from '@/graphql/querys/administracion/contratos/contrato/avanceReal/contratoCatalogoConceptos.gql';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [
    mixFormatoEstructura],
  data() {
    return {
      montoPrograma: 0,
      graficaFechaAl: new Date().toISOString().slice(0, 10),
      // graficaFechaAl: '2023-06-10',
    };
  },
  apollo: {
    contratoEstimaciones: {
      query: CONTRATO_ESTIMACIONES,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
    contratoCatalogoConceptos: {
      query: CONTRATO_CATALOGO_CONCEPTOS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  mounted() {
    this.$apollo.queries.contratoCatalogoConceptos.refetch({
      idContrato: this.idContrato,
    });

    this.$apollo.queries.contratoEstimaciones.refetch({
      idContrato: this.idContrato,
    });
  },
  computed: {
    getContrato() {
      if (!this.contrato) return [];
      return this.contrato;
    },
    getFechasAvancesReales() {
      const fechas = this.getContratoCatalogoConceptos
        .map((a) => a.avancesReales);
      return fechas;
    },
    getContratoCatalogoConceptos() {
      if (!this.contratoCatalogoConceptos) return [];
      return this.contratoCatalogoConceptos.filter(({ tipo }) => tipo === 2)
        .map((c) => ({
          ...c,
          avancesReales: c.avancesReales
            .filter(({ fecha }) => new Date(`${fecha} 00:00:0`) <= new Date(`${this.graficaFechaAl} 00:00:0`)),
        }));
      // return this.contratoCatalogoConceptos.filter(({ tipo }) => tipo === 2);
    },
    getEstimaciones() {
      if (!this.contratoEstimaciones) return [];
      return this.contratoEstimaciones
        .slice()
        .filter((e) => new Date(`${e.fechaAl} 00:00:0`) <= new Date(`${this.graficaFechaAl} 00:00:0`))
        .sort((a, b) => new Date(`${a.fechaAl} 00:00:0`) - new Date(`${b.fechaAl} 00:00:0`));
    },
    getUltimaEstimacion() {
      if (!this.getEstimaciones) return {};
      if (!this.getEstimaciones.length > 0) { return {}; }
      return this.getEstimaciones[this.getEstimaciones.length - 1];
    },
    getCliente() {
      if (!this.getContrato) return {};
      return this.getContrato.cliente;
    },
    getTipoSubtipo() {
      if (!this.getContrato.obras || this.getContrato.obras.length <= 0) { return ''; }
      const tipo = this.getContrato.obras[0].obra?.tipo?.descripcion || '';
      const subtipo = this.getContrato.obras[0].obra?.subtipo?.descripcion || '';
      if (tipo === 'OBRA') return 'CONTRATISTA';
      return subtipo;
    },
    mixPuntosGrafica() {
      let puntos = [];
      let puntosDel = [];

      if (!this.mixProgramasObras
        || this.mixProgramasObras.length === 0
        || !this.getEstimaciones) {
        return {
          puntos: [],
          puntosDel: [],
          puntosDelLetra: [],
          puntosLetra: [],
          ejeXLabels: [],
          programado: [],
          programadoPorcentaje: [],
          financiero: [],
          financieroPorcentaje: [],
          fisico: [],
          fisicoPorcentaje: [],
        };
      }

      const valoresEjeX = this.getValoresEjeX(this.mixProgramasObras,
        this.getEstimaciones,
        this.getContratoCatalogoConceptos);

      puntosDel = this.getFechasDel();
      puntos = valoresEjeX;
      const programado = this.getProgramadoList(puntos);
      const financiero = this.getFinancieroList(puntos).filter((p) => p > 0);
      const fisico = this.getFisicoList(puntos, this.getFinancieroList(puntos))
        .filter((p) => p > 0);

      const puntosFormato = puntos.map((p) => this.formatoFechaSeparador(p, { letra: true, separador: '-', formatoMes: 'corto' }));
      const puntosDelFormato = puntosDel.map((p) => this.formatoFechaSeparador(p, { letra: true, separador: '-', formatoMes: 'corto' }));

      return {
        puntos,
        puntosLetra: ['', ...puntosFormato],
        puntosDelLetra: ['', ...puntosDelFormato],
        ejeXLabels: ['', ...puntos.map((p, index) => index + 1)],
        programado: [0, ...programado.map((p) => p.importe)],
        programadoPorcentaje: [0, ...programado
          .slice()
          .map(({ importe }) => this
            .$numberRound((importe / programado[programado.length - 1].importe) * 100))],
        financiero: [0, ...financiero],
        financieroPorcentaje: [0, ...financiero
          .slice()
          .map((f) => this
            .$numberRound((f / programado[programado.length - 1].importe) * 100))],
        fisico: [0, ...fisico],
        fisicoPorcentaje: [0, ...fisico
          .slice()
          .map((f) => this
            .$numberRound((f / programado[programado.length - 1].importe) * 100))],
      };
    },
    mixProgramasObras() {
      if (!this.contratoProgramasObra || this.contratoProgramasObra.length <= 0) return [];
      return this.contratoProgramasObra;
    },
    mixGetPrograma() {
      if (!this.contratoProgramasObra || this.mixProgramasObras.length <= 0) return [];

      // Destructurar el primer progama
      const [{ programa }] = this.mixProgramasObras;

      // Suma de los montos
      let suma = 0;

      return programa
        // Ordernar el programa por fecha de termino
        .sort((a, b) => new Date(`${a.fechaTermino} 00:00:0`) - new Date(`${b.fechaTermino} 00:00:0`))
        // Calcular el porcentaje de avance
        .map((item) => {
          // Sumar el monto anterior con el monto actual
          suma += item.monto;

          // Regresar el objeto con el calculo de avance
          return {
            ...item,
            // Calcular porcentaje de avance programado
            avance: this.$numberRound((suma / this.montoPrograma) * 100),
          };
        });
    },
  },
  methods: {
    getFisicoList(puntos, financiero) {
      let fisicoImportes = [];
      const fechasImportesConceptosAvanceReal = this.getContratoCatalogoConceptos
        .map((c) => c.avancesReales.map((r) => ({
          fecha: r.fecha,
          importe: r.importe,
        })))
        .flat(1);

      fisicoImportes = financiero.map((item, index) => {
        const parcialesConceptos = fechasImportesConceptosAvanceReal
          .filter((f) => f.fecha === puntos[index]);
        const sumaParciales = this.$ObjSumar(parcialesConceptos, 'importe');
        if (item === 0 && index > 0 && sumaParciales > 0) {
          return financiero[index - 1] + this.$ObjSumar(parcialesConceptos, 'importe');
        }
        return item + sumaParciales;
      });
      return fisicoImportes;
    },
    getFinancieroList(puntos) {
      const fechasEstimaciones = this.getEstimaciones
        .map((e) => ({
          fechaAl: e.fechaAl,
          fechaDel: e.fechaDel,
          importe: e.importeCostoDirecto,
        }));

      const financieroImportes = puntos.map((p) => this.$ObjSumar(
        fechasEstimaciones.filter((e) => e.fechaAl === p)
          .map(({ importe }) => ({ importe })), 'importe',
      ));
      const importesAcumulados = [];
      financieroImportes.map((i, index) => {
        if (index > 0 && i > 0) {
          importesAcumulados.push(i + importesAcumulados[index - 1]);
        } else {
          importesAcumulados.push(i);
        }
        return true;
      });
      return importesAcumulados;
    },
    getProgramadoList(puntos) {
      return puntos.map((p) => this.mixCalcularPrograma(p));
    },
    getValoresEjeX(programaList, estimacionesList, avancerealList) {
      const fechasEstimaciones = estimacionesList
        .map(({ fechaAl }) => fechaAl);
      let ultimaFecha = fechasEstimaciones.slice(-1) || '';

      const fechasAvancesReales = avancerealList
        .map((p) => p.avancesReales.map(({ fecha }) => fecha))
        .flat(1)
        .filter((f) => f > ultimaFecha)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      const fechasParcial = fechasAvancesReales
        .filter((item, index) => fechasAvancesReales.indexOf(item) === index)
        .slice(-1);

      if (fechasParcial.length > 0) {
        ultimaFecha = fechasParcial.slice(-1) || '';
      }

      const [{ programa }] = programaList;
      const fechasPrograma = programa
        .map(({ fechaTermino }) => fechaTermino)
        .filter((f) => f > ultimaFecha)
        .sort((a, b) => new Date(`${a} 00:00:0`) - new Date(`${b} 00:00:0`));

      return [...fechasEstimaciones,
        ...fechasParcial,
        ...fechasPrograma];
    },
    getFechasDel() {
      // Obtener fechas de las estimaciones y sus importesCostoDirecto
      const fechasEstimaciones = this.getEstimaciones
        .map((e) => ({
          fechaAl: e.fechaAl,
          fechaDel: e.fechaDel,
          importe: e.importeCostoDirecto,
        }));

      const puntosDel = fechasEstimaciones
        .slice()
        .map((e) => e.fechaDel);
      return puntosDel;
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    sumarMontoAcumulado(programadoAnteriror) {
      if (!programadoAnteriror) return 0;
      return this.$ObjSumar(programadoAnteriror, 'monto');
    },
    calcularDiferenciaEnDias(fechaInicio, fechaTermino) {
      const nuevaFechaInicio = new Date(`${fechaInicio} 00:00:0`);
      const nuevaFechaTermino = new Date(`${fechaTermino} 00:00:0`);
      // Calcular
      const diferenciaMiliSegundos = Math.abs(nuevaFechaTermino - nuevaFechaInicio);
      const diferenciaDias = Math.ceil(diferenciaMiliSegundos / (1000 * 60 * 60 * 24));

      return (diferenciaDias + 1);
    },
    mixCalcularPrograma(fecha) {
      let total = 0;

      if (!fecha) {
        return {
          porcentaje: 0,
          importe: 0,
          diasTranscuridos: 0,
        };
      }
      // Fecha del avance
      const alFecha = new Date(`${fecha} 00:00:0`);
      // Comprobar que que exista un programa de obra
      if (this.mixProgramasObras.length <= 0) return 0;

      // Seleccionar el primer programa del listado de programas de obra del contrato
      const [programaUno] = this.mixProgramasObras;

      const diasTranscuridos = this.calcularDiferenciaEnDias(
        this.mixGetPrograma[0].fechaInicio,
        fecha,
      );

      // Acumulado del programa
      const programaAcumulado = programaUno.programa
        .filter((programa) => new Date(programa.fechaTermino) <= alFecha);

      // Importe acumulado
      const importeAcumulado = this.sumarMontoAcumulado(programaAcumulado);

      // Programa actual
      const programadoActual = programaUno.programa
        .filter((programa) => alFecha >= new Date(`${programa.fechaInicio} 00:00:0`)
      && alFecha < new Date(`${programa.fechaTermino} 00:00:0`));

      // Si no hay programado actual, entonces regresas el 100%
      // y, el importe acumulado actual
      if (programadoActual.length <= 0) {
        total = (importeAcumulado);

        return {
          porcentaje: this.$obtenerImporteDosDecimales((
            (total / this.montoPrograma) * 100)),
          importe: this.$obtenerImporteDosDecimales(total),
          diasTranscuridos,
        };
      }

      // Cantidad de dias ejecutados a la fecha
      const diasEjecutados = this.calcularDiferenciaEnDias(programadoActual[0].fechaInicio, fecha);

      // Cantidad de dias del periodo
      const diasDelPeriodo = this.calcularDiferenciaEnDias(
        programadoActual[0].fechaInicio,
        programadoActual[0].fechaTermino,
      );

      // Importe diario
      const importeDiario = (programadoActual[0].monto / diasDelPeriodo);

      // Importe ejecutado del periodo
      const importeEjecutadoDelPeriodo = (importeDiario * diasEjecutados);

      // Importe ejecutado
      const importeEjecutado = (importeAcumulado + importeEjecutadoDelPeriodo);

      total = importeEjecutado;

      // Porcentaje de avace
      const porcentajeProgramado = ((total / this.montoPrograma) * 100);

      // Regresar el porcentaje de avance programado y el importe ejecutado a la fecha
      return {
        porcentaje: this.$obtenerImporteDosDecimales(porcentajeProgramado),
        importe: this.$obtenerImporteDosDecimales(total),
        diasTranscuridos,
      };
    },
  },
};
